"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AwsApiType;
(function(AwsApiType) {
  AwsApiType[(AwsApiType["Primary"] = 0)] = "Primary";
  AwsApiType[(AwsApiType["AddOn"] = 1)] = "AddOn";
  AwsApiType[(AwsApiType["Action"] = 2)] = "Action";
})((AwsApiType = exports.AwsApiType || (exports.AwsApiType = {})));
//# sourceMappingURL=typeUtils.js.map
